<div class="bla-page">
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>

    <div class="bla-header">
        <h1 class="bla-title">BizDev Lookup Administration</h1>
        <p class="bla-subtitle">Manage reference data used across BizDev forms (competitors, win/loss reasons, lead status, probability, ownership interest).</p>
    </div>

    <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="activeTabIndex">
        <p-tabPanel *ngFor="let tab of tabs" [header]="tab.title">

            <div class="bla-tab-actions">
                <button pButton type="button"
                        icon="pi pi-plus"
                        label="Add New"
                        class="p-button-sm"
                        (click)="openAdd(tab)"
                        [disabled]="tab.showForm">
                </button>
                <button pButton type="button"
                        icon="pi pi-refresh"
                        label="Refresh"
                        class="p-button-sm p-button-text"
                        (click)="loadTab(tab)">
                </button>
            </div>

            <div *ngIf="tab.showForm" class="bla-form">
                <h3 class="bla-form-title">{{ tab.editing ? 'Edit' : 'Add' }} {{ tab.title }} Entry</h3>
                <div class="bla-form-grid">
                    <div class="bla-form-field">
                        <label>Label</label>
                        <input pInputText type="text" [(ngModel)]="tab.formModel.label" maxlength="200" />
                    </div>
                    <div class="bla-form-field">
                        <label>Value</label>
                        <input pInputText type="text" [(ngModel)]="tab.formModel.value" maxlength="200" />
                    </div>
                    <div class="bla-form-field bla-form-field-narrow">
                        <label>Sort Order</label>
                        <input pInputText type="number" [(ngModel)]="tab.formModel.sortOrder" />
                    </div>
                    <div class="bla-form-field bla-form-field-narrow">
                        <label>Active</label>
                        <p-inputSwitch [(ngModel)]="tab.formModel.active"></p-inputSwitch>
                    </div>
                </div>
                <div class="bla-form-buttons">
                    <button pButton type="button"
                            icon="pi pi-check"
                            label="Save"
                            class="p-button-sm"
                            (click)="save(tab)">
                    </button>
                    <button pButton type="button"
                            icon="pi pi-times"
                            label="Cancel"
                            class="p-button-sm p-button-text"
                            (click)="cancelForm(tab)">
                    </button>
                </div>
            </div>

            <p-table [value]="tab.rows" [loading]="tab.loading" styleClass="p-datatable-sm bla-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Label</th>
                        <th>Value</th>
                        <th class="bla-col-narrow">Sort Order</th>
                        <th class="bla-col-narrow">Active</th>
                        <th class="bla-col-actions">Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td>{{ row.label }}</td>
                        <td>{{ row.value }}</td>
                        <td class="bla-col-narrow">{{ row.sortOrder }}</td>
                        <td class="bla-col-narrow">
                            <span class="bla-badge" [class.bla-badge-active]="row.active" [class.bla-badge-inactive]="!row.active">
                                {{ row.active ? 'Yes' : 'No' }}
                            </span>
                        </td>
                        <td class="bla-col-actions">
                            <button pButton type="button"
                                    icon="pi pi-pencil"
                                    class="p-button-rounded p-button-text p-button-sm"
                                    (click)="openEdit(tab, row)"
                                    pTooltip="Edit">
                            </button>
                            <button pButton type="button"
                                    icon="pi pi-trash"
                                    class="p-button-rounded p-button-text p-button-danger p-button-sm"
                                    (click)="confirmDelete(tab, row)"
                                    pTooltip="Delete">
                            </button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" class="bla-empty">No entries yet. Click "Add New" to create one.</td>
                    </tr>
                </ng-template>
            </p-table>

        </p-tabPanel>

        <!-- Sales Agents tab -->
        <p-tabPanel header="Sales Agents">
            <div class="bl-agents-section">
                <p *ngIf="salesAgentsLoading"><i class="pi pi-spin pi-spinner"></i> Loading...</p>

                <!-- Current sales agents list -->
                <h4 style="margin:0 0 10px;color:#1a5276;">Current Sales Agents (BIZDEV_SALES_AGENT role)</h4>
                <div *ngIf="salesAgents.length === 0 && !salesAgentsLoading" style="color:#888;margin-bottom:16px;">
                    No sales agents assigned.
                </div>
                <ul style="list-style:none;padding:0;margin:0 0 20px;" *ngIf="salesAgents.length > 0">
                    <li *ngFor="let agent of salesAgents"
                        style="display:flex;align-items:center;justify-content:space-between;padding:8px 10px;border-bottom:1px solid #eee;">
                        <span>{{ agent.firstName }} {{ agent.lastName }} <small style="color:#888;">({{ agent.emailAddress }})</small></span>
                        <button pButton icon="pi pi-times" class="p-button-danger p-button-text p-button-sm"
                                (click)="removeSalesAgent(agent)" title="Remove from Sales Agents"></button>
                    </li>
                </ul>

                <!-- Add user -->
                <h4 style="margin:0 0 8px;color:#1a5276;">Add Sales Agent</h4>
                <div style="display:flex;gap:8px;align-items:center;max-width:400px;">
                    <input pInputText [(ngModel)]="userSearchQuery"
                           (ngModelChange)="searchUsers($event)"
                           placeholder="Search by name or email..."
                           style="flex:1;" />
                </div>
                <ul *ngIf="userSearchResults.length > 0"
                    style="list-style:none;padding:0;margin:8px 0;border:1px solid #ddd;border-radius:4px;max-height:200px;overflow-y:auto;">
                    <li *ngFor="let u of userSearchResults"
                        style="padding:8px 12px;cursor:pointer;border-bottom:1px solid #f0f0f0;"
                        (click)="addSalesAgent(u)">
                        {{ u.firstName }} {{ u.lastName }} — <small>{{ u.emailAddress }}</small>
                    </li>
                </ul>
            </div>
        </p-tabPanel>

    </p-tabView>
</div>
